// Cross-tab invalidation for the customer's bidding orders list.
//
// Any action that mutates a customer's orders (create / update / cancel
// / hire-bid / pay) writes a timestamp into a shared localStorage key.
// Other open tabs listening for the `storage` event see the write and
// refetch their cached data — so when the customer hires a writer in
// tab A, tab B's "Finish your order" banner disappears instead of
// lingering with stale data.
//
// `storage` fires ONLY in OTHER tabs (not the one that wrote), which is
// exactly the semantics we want — the writing tab already has fresh
// local state and doesn't need to re-fetch.
const KEY = 'bidding_orders_changed_at';

export function signalOrdersChanged() {
    try {
        window.localStorage.setItem(KEY, String(Date.now()));
    } catch (_) { /* quota / private mode — silent */ }
}

export function subscribeToOrdersChanged(callback) {
    if (typeof window === 'undefined') return () => {};
    const onStorage = (e) => {
        if (e.key === KEY) callback();
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
}
